<template>
	<app-page>
		<app-heading title="Activate complexes" />
		<app-row>
			<app-cell>
				<div class="mb-4">
					<app-button
						v-if="$ravello.can('website.post')"
						color="success"
						icon="fa-check"
						small
						@click="onActivateSelected()"
						:disabled="!selected || !selected.length"
					>
						Activate
					</app-button>
				</div>
				<app-data-table
					:items="complexes"
					:headers="headers"
					:total="count"
					:select="$ravello.can('website.post')"
					sort-by="code"
					search
					@search="onSearch"
					@select="updateSelection"
					@update="fetchComplexes"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('website.post')"
							color="success"
							icon="fa-check"
							table
							:loading="loading[item._id]"
							:disabled="activated[item._id]"
							@click="onActivate(item._id)"
						>
							Activate
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
import { mapAll } from '@/utils/async'
import { search } from '@/mixins'

export default {
	mixins: [search],
	data() {
		return {
			website: {},
			complexes: [],
			selected: [],
			activated: {},
			loading: {},
			map: {},
			count: -1,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
	},
	async mounted() {
		this.website = await this.$ravello.graphql('website', this.websiteId)
			.field('name')
			.query()
	},
	methods: {
		async fetchComplexes(pagination) {
			const request = this.$ravello.graphql('complexes')
				.parent(this.$ravello.graphql('connection')
					.parent(this.$ravello.graphql('website', this.websiteId)))
				.fields(['_id', 'name'])
				.fromPagination(pagination)

			if (this.count === -1 && !this.searchText) {
				request.count('count')
			}

			if (this.searchText) {
				request.search(this.searchText)
			}

			try {
				this.complexes = await request.query()

				if (this.searchText) {
					this.count = this.complexes.length
				}
				if (this.count === -1) {
					this.count = request.results.count
				}
				await this.updateActivated()
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		updateSelection(selected) {
			this.selected = selected
		},

		async updateActivated() {
			const activatedComplexes = await this.$ravello.graphql('complexes')
				.parent(this.$ravello.graphql('website', this.websiteId))
				.fields(['_id', 'active'])
				.include(this.$ravello.graphql('complex').field('_id'))
				.limit(this.complexes.length)
				.filter('complex', this.complexes.map(complex => complex._id))
				.query()

			this.activated = activatedComplexes
				.reduce((acc, complex) => ({ ...acc, [complex.complex._id]: complex.active }), {})

			this.ids = activatedComplexes
				.reduce((acc, complex) => ({ ...acc, [complex.complex._id]: complex._id }), {})
		},

		async onActivate(id) {
			this.loading[id] = true
			try {
				if (typeof this.ids[id] !== 'undefined') {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('complexes')
						.to(this.ids[id])
						.update({ active: 1 })
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('complexes')
						.create({ active: 1, complex: id })
				}
				this.activated = { ...this.activated, [id]: true }
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			delete this.loading[id]
		},

		async onActivateSelected() {
			this.$store.dispatch('app/startLoading')
			await mapAll(this.selected, id => this.onActivate(id))
			this.$store.dispatch('app/stopLoading')
			this.selected = []
		},
	},
}
</script>
